import { render, staticRenderFns } from "./RoasterTable.vue?vue&type=template&id=4c28d7a1&scoped=true"
import script from "./RoasterTable.vue?vue&type=script&lang=js"
export * from "./RoasterTable.vue?vue&type=script&lang=js"
import style0 from "./RoasterTable.vue?vue&type=style&index=0&id=4c28d7a1&prod&lang=css"
import style1 from "./RoasterTable.vue?vue&type=style&index=1&id=4c28d7a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c28d7a1",
  null
  
)

export default component.exports